<!--
목적 : 공정팝업 컴포넌트
-->
<template>
  <div class="fix-height">
    <q-field
      ref="customProcess"
      class="customProcess"
      :dense="dense"
      stack-label
      color="orange-7"
      :label="label"
      :disable="disabled||!editable"
      :rules="!required ? null : [val => !!val || '']"
      v-model="valueText"
      >
      <template v-slot:label v-if="label">
        <div class="row items-center all-pointer-events">
          <b>
            <i v-if="!required" class="pe-7s-note labelfrontIcon searchAreaLabelIcon"></i>
            <font class="formLabelTitle">{{label}}</font>
            <i v-if="required" class="material-icons labelfrontIcon text-requiredColor">check</i>
          </b>
        </div>
      </template>
      <template v-slot:control>
        <q-chip
          v-for="(process, index) in processes"
          :key="index"
          :removable="!disabled&&editable"
          color="orange-6"
          text-color="white"
          class="q-ma-none customchipdept"
          @remove="remove(process)">
          {{process.processName}}
        </q-chip>
      </template>

      <template v-slot:append>
        <q-icon v-if="!disabled&&editable" name="search" @click="search" class="cursor-pointer"></q-icon>
        <q-icon v-if="!disabled&&editable" name="close" @click="reset" class="cursor-pointer"></q-icon>
      </template>
    </q-field>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'c-process',
  props: {
    name: {
      type: String,
      default: 'field',
    },
    // TODO : 부모의 v-model의 값을 받아오는 속성
    value: { // 사용자의 id를 받아 처리
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    // 쓰기 권한 여부
    editable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'process', // upprocess 상위공정
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 필수 입력 여부
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: String,
      default: 'single',
    },
    plantCd: {
      type: String,
      default: '', // 10:상위공정, 20: 단위공정
    },
    stype: {
      type: String,
      default: '20', // 10:상위공정, 20: 단위공정
    }
  },
  data() {
    return {
      vValue: null,
      valueText: '',
      processes: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '60%',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
  },
  watch: {
    // todo : 부모의 v-model 변경을 감시
    value: {
      handler: function () {
        this.vValue = this.value;
        this.setValueText();
      },
      deep: true,
    },
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  beforeMount() {
    this.vValue = this.value;
    this.setValueText();
  },
  mounted() {
    if (!this.disabled) {
      this.$refs['customProcess'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  beforeDestroy() {
    if (!this.disabled) {
      this.$refs['customProcess'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  /* methods */
  methods: {
    /**
     * v-model로 받은 값을 통해 사용자 정보 조회
     *
     * type에 따라 valueText에 표시되는 값 변경
     */
    setValueText() {
      if (this.vValue) {
        this.$http.url = selectConfig.mdm.process.nameObject.url;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.plantCd,
          processCds: this.$_.split(this.vValue, ',')
        }
        this.$http.request((_result) => {
          this.processes = _result.data
          if (_result.data && _result.data.length > 0) {
            this.valueText = this.$_.map(_result.data, 'processName').join(',');
          } else {
            this.valueText = '';
          }
        },
        () => {
        });
      } else {
        this.processes = [];
        this.valueText = '';
      }
    },
    search() {
      if (this.type === 'process') {
        this.popupOptions.title = '단위공정 검색';
        this.popupOptions.param = {
          type: this.multiple,
          processLevelCd: '20'
        };
      } else {
        this.popupOptions.title = '상위공정 검색';
        this.popupOptions.param = {
          type: this.multiple,
          processLevelCd: '10'
        };
      }
      this.popupOptions.target = () => import(`${'@/pages/common/process/processPop.vue'}`);
      this.popupOptions.width = '50%';
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (this.multiple === 'single') {
          this.valueText = data[0].processName;
          this.$emit('processName', data[0].processName);
          this.$emit('input', data[0].processCd);
          this.$emit('datachange', data[0]);
        } else {
          this.valueText = this.$_.map(data, 'processName').join(',');
          this.$emit('processName', this.valueText);
          this.$emit('input', this.$_.map(data, 'processCd').join(','));
          this.$emit('datachange', data);
        }
      }
    },
    reset() {
      this.valueText = '';
      this.$emit('processName', null);
      this.$emit('input', null);
      this.$emit('datachange', null);
    },
    remove(process) {
      let _processes = this.$_.cloneDeep(this.processes);
      _processes.splice(this.$_.findIndex(_processes, { processCd: process.processCd }), 1);
      let emitProcess = this.$_.map(_processes, 'processCd')
      this.$emit('processName', this.$_.map(_processes, 'processName').toString());
      this.$emit('input', emitProcess.toString());
      this.$emit('datachange', emitProcess);
    },
  },
};
</script>
<!-- <style lang="sass">
.customProcess
  .q-field__control-container
    padding-bottom: 2px !important
  padding-bottom: 14px !important
  .q-field__native.row
    padding-left: 3px
    font-size: 0.95em
    padding-top: 4px !important
  .q-field__native
    padding-bottom: 0px !important
    cursor: pointer
  .q-field__label
    margin-left: 5px
  .material-icons
    font-size: 0.8rem
  .dateCloseIcon
    font-size: 0.8rem !important
    display: none
.customProcess:hover
  .dateCloseIcon
    display: block
.customProcess.q-field--dense .q-field__control, .customProcess.q-field--dense .q-field__marginal
  height: 33px !important
  min-height: 31px !important
  height: min-content !important
.customProcess.q-field--filled .q-field__control
  border: 1px solid rgba(0,0,0,0.15) !important
  padding: 0px 8px 0px 2px
.customchipdept.q-chip
  margin-top: -3px !important
  margin-right: 3px !important
  .q-chip__content
    font-size: 0.95em !important
</style> -->